module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAlQTFRFAAAAGjMzJjpBPYPICQAAAAN0Uk5TAAr/LZvD2QAAAFVJREFUeJxjYIACUQcGBIgKQLAZs6YgOKyrliA4YsicqFVTkLSsCkDSstIBScvSIaaFAVkLQxaSFjQOsjIUA1CMRrGUcQhrWoKsCYmDklxQEhI4iQEAEMhB2TGabSMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-left.png
// module id = OQks
// module chunks = 1